import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { identify, trackPageLoad } from '@fff-web/fff-analytics';
import { useUserContext } from '@fff-web/fff-utilities';

export const usePageTracking = () => {
  const { userInfo } = useUserContext();
  const { userId } = userInfo.user;
  const { pathname } = useLocation();

  const tracked = useRef(false);

  useEffect(() => {
    // unset tracked when path changes. This hook is first so it runs first
    tracked.current = false;
  }, [pathname]);

  useEffect(() => {
    if (tracked.current || !userId) return;
    tracked.current = true;

    const optimizelyOptions = {
      Optimizely: {
        userId: (userId ?? 0).toString(),
      },
    };

    // retry many times until track succeeds, we do this to avoid the race condition of analytics not being ready
    const tryTrack = async () => {
      let succeeded = false;
      await trackPageLoad({
        properties: { user_id: userId },
        options: optimizelyOptions,
        callback: () => {
          succeeded = true;
          // call identify once track succeeds since we know analytics is ready
          identify();
        },
      });

      if (!succeeded) {
        // try again in 1 sec
        window.setTimeout(() => {
          tryTrack();
        }, 1000);
      }
    };

    tryTrack();
  }, [pathname, userId]);
};
